import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const Error = () => {
	return (
		<>
			<Navbar />
			
			<main>
				<h1>Error</h1>
			</main>

			<Footer />
		</>
	)
}

export default Error;